'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { DocsLinks } from '@/components/how-it-works/docs-links';
import { Award01Icon, Globe02Icon, Rocket01Icon, TradeUpIcon } from '@/components/ui/icon/glyphs';
import { InfoModal } from '@/components/ui/info-modal';
import { useGraduationModalStore } from '@/stores/graduation-modal';

/**
 * Explains what "graduation" means — opened from the underlined "What is
 * graduation?" cross-link inside the Markets and Winners how-it-works modals.
 * When a market resolves, the winning side becomes its own tradable token.
 *
 * Store-driven and mounted once at the app-shell level so a single instance
 * serves every cross-link surface.
 */
export function GraduationHowItWorksModal() {
  const $ = _c(57);
  const t = useTranslations("graduation_how_it_works");
  const open = useGraduationModalStore(_temp);
  const setOpen = useGraduationModalStore(_temp2);
  let t0;
  if ($[0] !== t) {
    t0 = t("title");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t) {
    t1 = t("description");
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t) {
    t2 = t("got_it");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== setOpen) {
    t3 = () => setOpen(false);
    $[6] = setOpen;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <InfoModal.Footer cta={t2} onClose={t3} />;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t) {
    t5 = t("locked_title");
    $[11] = t;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t) {
    t6 = t("locked_description");
    $[13] = t;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t5 || $[16] !== t6) {
    t7 = <InfoModal.IconItem icon={Award01Icon} title={t5} description={t6} />;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t) {
    t8 = t("token_title");
    $[18] = t;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t) {
    t9 = t("token_description");
    $[20] = t;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t8 || $[23] !== t9) {
    t10 = <InfoModal.IconItem icon={Rocket01Icon} title={t8} description={t9} />;
    $[22] = t8;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t) {
    t11 = t("trades_title");
    $[25] = t;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t) {
    t12 = t("trades_description");
    $[27] = t;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== t11 || $[30] !== t12) {
    t13 = <InfoModal.IconItem icon={Globe02Icon} title={t11} description={t12} />;
    $[29] = t11;
    $[30] = t12;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== t) {
    t14 = t("grow_title");
    $[32] = t;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== t) {
    t15 = t("grow_description");
    $[34] = t;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== t14 || $[37] !== t15) {
    t16 = <InfoModal.IconItem icon={TradeUpIcon} title={t14} description={t15} />;
    $[36] = t14;
    $[37] = t15;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  let t17;
  if ($[39] !== t10 || $[40] !== t13 || $[41] !== t16 || $[42] !== t7) {
    t17 = <InfoModal.IconList>{t7}{t10}{t13}{t16}</InfoModal.IconList>;
    $[39] = t10;
    $[40] = t13;
    $[41] = t16;
    $[42] = t7;
    $[43] = t17;
  } else {
    t17 = $[43];
  }
  let t18;
  if ($[44] !== t) {
    t18 = t("callout");
    $[44] = t;
    $[45] = t18;
  } else {
    t18 = $[45];
  }
  let t19;
  if ($[46] !== t18) {
    t19 = <InfoModal.Callout>{t18}</InfoModal.Callout>;
    $[46] = t18;
    $[47] = t19;
  } else {
    t19 = $[47];
  }
  let t20;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <DocsLinks docsPath="/concepts/graduation" />;
    $[48] = t20;
  } else {
    t20 = $[48];
  }
  let t21;
  if ($[49] !== open || $[50] !== setOpen || $[51] !== t0 || $[52] !== t1 || $[53] !== t17 || $[54] !== t19 || $[55] !== t4) {
    t21 = <InfoModal open={open} onOpenChange={setOpen} size="lg" title={t0} description={t1} footer={t4}>{t17}{t19}{t20}</InfoModal>;
    $[49] = open;
    $[50] = setOpen;
    $[51] = t0;
    $[52] = t1;
    $[53] = t17;
    $[54] = t19;
    $[55] = t4;
    $[56] = t21;
  } else {
    t21 = $[56];
  }
  return t21;
}
function _temp2(s_0) {
  return s_0.setOpen;
}
function _temp(s) {
  return s.open;
}